<app-loader *ngIf="!isLoaded"></app-loader>

<ng-container *ngIf="isLoaded">
    <div class="travels-list" *ngIf="travels?.length; else emptyTravels">
        <ng-container *ngFor="let travel of travels; let i = index">
            <div class="travels-item-wrapper" (click)="openTravelProfile($event, travel)">
                <div class="travels-list-item travels-item"
                     [ngStyle]="{
                     backgroundImage: 'linear-gradient(185.01deg, rgba(255, 255, 255, 0) 60.29%, rgb(255, 255, 255) 85.24%), ' + 'url(' + travel.image + ')',
                     backgroundSize: 'cover'
                 }"
                >
                    <!--                <div class="">-->
                    <!--                    <img *ngIf="travel?.image" [src]="travel.image" alt="travel image" class="img-travel-header">-->
                    <!--                </div>-->
                    <div class="travels-item-header"> Путешествие в {{travel.locationNames}}</div>
                </div>
                <div class="travel-item-status fa waiting-confirmation"
                     *ngIf="(type == 1 || type == 2 ) && [1,2,3,7,8].indexOf(travel.status.id) >= 0"
                >
                    <span > </span> Ожидает подтверждения
                </div>

                <div class="travel-item-status fa confirmed"
                     *ngIf="(type == 1 || type == 2 ) && [4].indexOf(travel.status.id) >= 0"
                >
                    <span > </span> Подтверждено

                </div>
                <div class="travel-item-status fa completed"
                     *ngIf="(type == 3 )"
                >
                    <span > </span> Завершено
                </div>

                <div class="travel-details-wrapper">
                    <div class="travel-item-details">
                        <div class="travels-item-dates">
                            <span class="lnr lnr-calendar-full"></span>
                            {{travel.dateFrom | momentDate}} -  {{travel.dateTo | momentDate}}
                        </div>
                        <div class="travels-item-people" *ngIf="travel.passengers?.length > 1 && travel.passengers?.length < 5">
                            <span class="lnr lnr-users" ></span>
                            {{travel.passengers?.length}}  человека
                        </div>
                        <div class="travels-item-people" *ngIf="travel.passengers?.length === 1 || travel.passengers?.length > 5">
                            <span class="lnr lnr-users" ></span>
                            {{travel.passengers?.length}}  человек
                        </div>
                    </div>

                    <div [class.travel-chevron]="type == 1 || type == 2 ">
                        <span class="lnr lnr-chevron-right"></span>
                    </div>
                </div>


            </div >

        </ng-container>
    </div>
    <ng-template #emptyTravels>
        <div class="empty-block">
            <span *ngIf="type === 1">У вас нет активных путешествий</span>
            <span *ngIf="type === 2">У вас нет запланированных путешествий</span>
            <span *ngIf="type === 3">У вас нет прошедших путешествий</span>
        </div>
    </ng-template>
</ng-container>
